import { Command } from '@approvalmax/types';
import { State } from 'modules/data';

import { getLoading } from './pageSelectors';

export function getAuthCommand(state: State): Command {
    const loading = getLoading(state);

    return {
        disabled: loading,
    };
}
